/* eslint-disable unicorn/filename-case */
/* eslint-disable camelcase */

export const zhCN = {
  welcome_login: "欢迎登录",
  account: "账号",
  password: "密码",
  remember_pwd: "记住密码",
  login: "登录",
  login_account_required: "必须输入用户名",
  login_pwd_required: "必须输入密码",
  input_keyword_search: "请输入关键字搜索",
  learning_data: "学习数据",
  my_course: "我的课程",
  my_exam: "我的考试",
  more_courses: "更多课程",
  exam_review: "考试评审",
  departmental_course: "部门教程",
  update_tutorial: "更新教程",
  all: "全部",
  pending_participation_exam: "待参加",
  pending_review_exam: "待评审",
  not_passed_exam: "未通过",
  passed_exam: "已通过",
  course_number: "课程编号",
  course_title: "课程名称",
  exam_time: "考试时间",
  exam_duration: "考试时长",
  quiz_creator: "出题人",
  total_question_number: "总题数",
  exam_number: "考试编号",
  remaining_exam_attempts: "剩余考试次数",
  times: "次",
  check_score: "查看成绩",
  start_exam: "开始考试",
  compulsory_course: "必修",
  elective_course: "选修",
  duration: "时长",
  course: "课程",
  featured: "教程",
  pcs: "个",
  minutes: "分钟",
  data_learned: "已学习", // 不確定
  to_learn: "待学习",
  learned: "已学习",
  learning: "学习中",
  history: "历史记录",
  learning_dueation: "学习时间",
  lecturer: "讲师",
  exam_start_time: "考试开始时间",
  exam_end_time: "考试结束时间",
  // score: "得分：{{score}}分",
  score_one: "得分：{{score}}分",
  score_other: "得分：{{score}}分",
  view_details: "查看详情",
  copy_link: "复制链接",
  failed_grade: "不及格",
  passed_grade: "及格",
  single_choice: "单选",
  multiple_choice: "多选",
  judgment: "判断",
  fill_blank: "填空",
  // total_score: "总分：{{totalScore}}分",
  total_score_one: "总分：{{totalScore}}分",
  total_score_other: "总分：{{totalScore}}分",
  // questions_total: "共{{questionCount}}题",
  questions_total_other: "共{{questionCount}}题",
  questions_total_one: "共{{questionCount}}题",
  exam_submission_time: "考卷提交时间",
  exam_paper_number: "考卷编号",
  number_of_associated_course: "关联课程编号",
  exam_marker: "评卷人",
  number_of_questions_to_be_reviewed: "待评审题数",
  review_status: "评审状态",
  operation: "操作",
  to_be_reviewed: "待评审",
  reviewed: "已评审", // 未确定
  distributed: "已派发", // 未确定
  review: "评审",
  department: "部门",
  position: "职位",
  nameOfViewer: "观看人姓名",
  organizationOfTheViewer: "观看人所属组织",
  viewingStatus: "观看状态",
  viewingTime: "观看时间",
  question_and_answer: "问答",
  i_posted: "我发布的",
  name: "名称",
  description: "描述",
  personnel_scope: "人员范围",
  shelf_time: "上架时间",
  courseware_upload: "课件",
  click_or_drag: "点击或将文件拖拽到这里上传",
  courseware_stage_has_exam: "课件所在阶段有考试",
  extension_support: "支持扩展名",
  cancel: "取消",
  confirm: "确认",
  organizational_structure: "组织架构",
  personnel_structure: "人员架构",
  selected: "已选人员",
  message_center: "消息中心",
  message_list: "消息列表",
  unread_message: "未读消息",
  read_message: "已读消息",
  on_the_shelf: "上架中",
  removed_from_shelves: "已下架",
  no_related_content: "抱歉，没有找到相关内容",
  unwatched: "未观看",
  watching: "观看中",
  watched: "已观看",
  viewing_record: "观看记录",
  my_viewing_record: "我的观看记录",
  delete: "删除",
  modify: "修改",
  publisher: "发布者",
  viewing_time: "观看时间",
  name_of_viewer: "观看人姓名",
  organization_of_the_viewer: "观看人所属组织",
  viewing_status: "观看状态",
  tutorial_staff_watches_the_record: "教程人员观看记录",
  course_introduction: "课程简介",
  more: "更多",
  course_evaluation: "课程评价",
  correctAnswerMessage: "恭喜你，回答正确！",
  wrongAnswer: "很遗憾，回答错误！",
  yourAnswer: "您的答案：{{yourAnswer}}",
  correctAnswer: "标准答案：{{correctAnswer}}",
  answerAnalysis: "答案解析：{{answerAnalysis}}",
  comment: "评语：{{comment}}",
  mark: "评分：{{score}}分",
  remainingTime: "剩余时间：",
  submit: "提交",
  submit_failed: "提交失败，请重试！",
  submit_success: "提交成功！",
  viewing_history: "观看历史记录",
  courseware_name: "课件名称",
  courseware_number: "课件编号",
  dept_course: "部门教程",
  dept_tutorials_number: "部门教程编号",
  my_dept_tutorials: "我学习的部门教程",
  course_description: "课程描述",
  tutorial_publish: "教程发布",
  tutorial_description: "教程简介",
  copy: "复制",
  copy_success: "复制成功",
  copy_failed: "复制失败",
  i_learned: "我学习的",
  multiplier: "倍速",
  clarity: "清晰度",
  whether_to_delete_data: "是否删除数据",
  whether_to_give_up_save: "是否确认放弃保存",
  yes: "是",
  no: "否",
  file_type_not_supported: "仅支持MP4、MOV、JPG、PNG、PDF格式",
  student_count: "学员总数",
  course_instructor: "课程讲师",
  learning_progress: "学习进度",
  my_pending_courses: "我的待学习课程",
  dept_course_number: "部门课程编号",
  join_course: "是否参与课程",
  course_expired: "课程已超出可学习时间，无法进行学习",
  no_tutorials: "暂无教程",
  upload_type_tips: "只能上传同一类附件，且MP3、MP4和PDF只能上传一份",
  examination_title: "考试名称", // 不確定
  paper_number: "考卷编号", // 不確定
  submitter: "提交人", // 不确定
  submission_time: "提交时间", // 不確定
  distribution_success: "成绩派发成功", // 不確定
  distribute: "派发成绩", // 不確定
  attachment: "附件",
  confirm_exit_exam: "是否退出考试？",
  clear_unread: "一键已读",
  scan_qr_code: "请扫描以上二维码填写课程评价",
  distribution_select_results: "请选择要派发的成绩", // 不确定
  pending_examination: "待审批考试", // 不确定
  test_paper_submission_time: "考卷提交时间", // 不確定
  answer: "答案", // 不確定
  review_score: "评分", // 不確定
  points: "分", // 不確定
  review_remark: "评语", // 不確定
  review_remark_empty: "评语不能为空", // 不确定
  review_points_empty: "评分不能为空", // 不确定
  tutorials: "教程",
  tutorials_number: "教程编号",
  logout: "退出",
  version: "版本号",
  empty_exams: "暂无考试",
  empty_course: "暂无课程",
  empty_score: "暂无成绩",
  empty_content: "暂无内容",
  clear: "清空",
  echo_avatar: "Echo Avatar",
  translation_video: "翻译视频",
  start_make: "开始制作",
  sure_make: "确认制作",
  cancel_making: "关闭",
  cancel_make: "取消制作",
  language: "语种",
  tone: "音色",
  make_state: "制作状态",
  speech_draft: "讲稿",
  download: "下载",
  download_failed_open_tab: "下载失败，请在新标签自行下载",
  try_listen: "试听",
  template_download: "模版下载",
  output_language_speech_color_selection: "输出语种语音色选择",
  original_language: "原始语言",
  translation_language: "转译语种",
  video_duration: "视频时长",
  video_name: "视频名称",
  ea_note: "注：如需克隆音色，请到Echo Avatar客户端制作（请使用同一账号登录）",
  ea_tooltip:
    "讲稿可自行选择是否导入；如不导入，系统将对视频中的音频进行人工智能识别，智能生成讲稿；如导入，系统将按照讲稿内容进行多语种版本制作。",
  total_video_duration: "视频总时长",
  original: "原文",
  translation: "译文",
  word_count: "字数",
  back: "返回",
  sure: "确定",
  preview: "预览",
  batch_download: "批量下载",
  multilingual_translation: "多语言转译",
  ea_hash: "Hash",
  making: "制作中",
  please_select_the_original_language: "请选择原始语言",
  please_select_the_target_language: "请选择目标语言",
  please_select_language: "请选择语种",
  please_select_a_tone: "请选择音色",
  whether_to_cancel_production: "是否取消制作",
  search_history: "搜索历史",
  target_language: "目标语言",
  create_translation_video: "创建翻译视频项目",
  advanced_option: "高级选项",
  subtitles: "字幕",
  video_advanced_option: {
    option1: "保留背景音（保留配乐、噪音等非人声）",
    option2: "直接翻译（跳过校验文本环节，直接输出结果视频）",
    option3: "字幕（生成目标语言字幕）",
  },
  original_language_and_target_language_conflict:
    "原始语言不能与目标语言相同，请重新选择",
  save: "保存",
  translate: "翻译",
  ai_analysis: "AI分析",
  regular_duration: "常规用时",
  recommended_duration: "推荐用时",
  ai_rewrite: "AI重写",
  slow_speech_rate_tip: {
    option1: "语速缓慢",
    option2: "翻译后的文本比原始文本短。我们建议增加自然语言节奏的字符数。",
  },
  fast_speech_rate_tip: {
    option1: "语速过快",
    option2: "翻译后的文本比原始文本长。我们建议减少自然语言节奏的字符数。",
  },
  subtitle_time_range_is_incorrect: {
    option1: "开始时间不能超过结束时间",
    option2: "结束时间不能超过下一句的开始时间",
  },
  video_time_format: "时间格式为HH:mm:ss,mmm",
  making_tips: "正在生成 {{progress}}%",
  no_data: "暂无数据",
  index_page: "首页",
  share: "分享",
  playing_failed: "播放失败",
  intelligent_creation: {
    intelligent_creation: "智能创作",
    ai_podcast: "AI 播客",
    creation_type: "创作类型",
    audio: "音频",
    video: "视频",
    upload_text: "点击上传",
    upload_tip: "仅支持上传.pdf，且大小不超过10mb",
    podcard_content_tip: "请输入播客内容或上传PDF文件",
    ai_creation: "AI 创作",
    use_my_script: "用我的脚本",
    podcast_content_input_placeholder_ai:
      "输入主题、想法或上传参考资料，让 AI 一键生成完整播客脚本。",
    podcast_content_input_placeholder_custom:
      "输入已有的脚本，系统自动转成对应播客脚本。",
    script_format_requirement:
      '格式提示：\n·需换行区分"主持人"和"采访嘉宾"的对白。\n·对话角色仅限"主持人"和"采访嘉宾"。',
    script_format_example:
      "【格式示例】\n主持人：哈喽各位……\n采访嘉宾：对的，我们……\n主持人：那……\n采访嘉宾：是的，其实……",
    script_format_error: "脚本不符合格式要求，请编辑后重试。",
    input_script_placeholder: "请输入脚本",
    apply_script: "应用脚本",
    mandarin: "普通话",
    cantonese: "粤语",
    compere: "主持人",
    interview_guest: "采访嘉宾",
    my_tone: "我的音色",
    digital_image_and_timbre: "数字形象和音色",
    my_customization: "我的定制",
    system_tone: "系统音色",
    podcast_content: "播客内容",
    system_presets: "系统预设",
    custom: "自定义",
    customize: "定制",
    tone_genere_tip: "音色生成中，预计等待{{minutes}}分钟",
    generate_script: "生成脚本",
    too_long_script_tip:
      "脚本整体篇幅过长，不符合时长设置，请重新编辑或通过指令让AI协助修改。",
    too_short_script_tip:
      "脚本整体篇幅过短，不符合时长设置，请重新编辑或通过指令让AI协助修改。",
    generate_audio: "生成音频",
    generate_video: "生成视频",
    audio_balance: "音频余额(时:分:秒)",
    video_balance: "视频余额(时:分:秒)",
    audio_generate_tip:
      "注：因AI生成特性，最终音视频时长可能存在一定偏差，额度扣减将按实际时长执行。",
    no_content: "请先完成设置～",
    tone_customization: "音色定制",
    upload_file_tip1: "文件过大，请重新上传",
    upload_file_tip2: "时长不符合要求，请重新上传",
    whether_to_confirm_deletion: "是否确认删除？",
    whether_to_confirm_submission: "是否确认提交？",
    material_text: "素材文本",
    material_text_tip:
      "文本由AI识别生成，如和原素材不一致，可自行修改，以提升音色克隆准确度。",
    material_language: "素材语种",
    tone_name: "音色名称",
    reference_audio: "参考音频",
    upload_audio_tip:
      '请上传个人清晰的人声音频（语种需和"素材语种"一致，要求无背景杂音、仅1个人的声音）',
    upload_audio_tip2: "格式：MP3 大小：150MB以內",
    generating: "生成中",
    script_generating: "脚本生成中",
    script_generat_failed: "脚本生成失败,请重新尝试",
    basic_setting_changed_tip: "设置已修改，请重新生成脚本！",
    delete_tone_tip1: "音色已被选择，无法删除，请调整后重试",
    delete_tone_tip2: "音频正在生成中，无法删除",
    generate_failed_tip: "生成失败，请重新尝试",
    queuing_tip: "排队中，预计等待几分钟",
    queuing_tip1: "排队中，预计{{minutes}}分钟后开始生成",
    submit_tip: "（提交后无法再次修改）",
    draft_tip: "提示",
    draft_tip1: "存在排队中/生成中/已完成的生成任务，是否继续？",
    draft_tip2: "（放弃后将不做保存）",
    back_tip1: "是否确认返回？",
    back_tip2:
      "（如有排队中/生成中/已完成的生成任务，下次进入时可再次查看，如无则不做保存）",
    background_sound_error_tip: "背景杂音明显，请重新上传",
    invalid_voice_error_tip: "未检测到有效人声，请重新上传",
    multiple_voices_error_tip: "检测到多人声音，请重新上传",
    audio_check_failed_error_tip: "检测失败，请重新上传",
    no_pdf_file_error_tip: "不是 PDF 文件，请重新上传",
    checking: "检测中",
    host: "主持人",
    guest: "采访嘉宾",
    digital_image: "数字形象",
    digital_image_group: "数字形象组合",
    my_digital_images: "我的数字形象",
    no_digital_image_tip: "暂无选项，请先完成定制！",
    ai_generate: "AI生成",
    over_word_limit_tip: "字数已达上限，超出部分无法录入。",
    upload_photo: "上传照片",
    upload_photo_tip1:
      "请上传个人照片（单人、正面，确保脸部无遮挡），用于生成数字形象",
    upload_photo_tip2: "格式：png/jpg 大小：10MB以内",
    under_inspection: "检测中",
    digital_image_customization: "数字形象定制",
    least_one_dialogue_box_tip: "最少要有一个对话框",
    detect_faild_tip: "服务繁忙, 请稍后重试",
    no_full_face_image_tip: "请上传完整正脸照片",
    no_single_person_image_tip: "仅支持单人照片，请重新上传",
    contains_illegal_content_tip: "含违规内容，请重新上传",
    clarity_low_tip: "清晰度过低，请重新上传",
    no_original_image_tip: "请直接上传原图",
    simple_chinese: "简体中文",
    traditional_chinese: "繁体中文",
    over_limit_tip: "{{name}}已超当前可用上限，如需新增，请先删除超出部分。",
    personal_tone: "个人音色",
    personal_digital_image: "个人数字形象",
    personal_digital_image_tip: "请先新增数字形象组合",
    personal_tone_tip: "音色不能为空",
    no_generation_result: "暂无生成结果",
  },
  input_placeholder: "请输入",
  no_permissions: "暂无权限",
  add: "新增",
  delete_success: "删除成功",
};
